import { Button } from '@loadsmart/miranda-react'

import { useChatContext } from './ChatContext'
import { ChatWindow } from './ChatWindow'
import { useChatDrawer } from './hooks/useChatDrawer'

export type ChatOpenerActionProps = {
  disabled?: boolean
  hasUnread?: boolean
  onClick?: () => void
}

export function Chat({ disabled, onClick, hasUnread }: ChatOpenerActionProps) {
  const { openConversation } = useChatContext()
  const { isOpen, isMounted, open, close, onClosed } = useChatDrawer()

  function handleOpen() {
    onClick?.()
    openConversation()
    open()
  }

  return (
    <>
      <Button
        size="small"
        variant={hasUnread ? 'primary' : 'secondary'}
        onClick={handleOpen}
        disabled={disabled}
      >
        Open chat
      </Button>
      {isMounted && <ChatWindow isOpen={isOpen} onClose={close} onClosed={onClosed} />}
    </>
  )
}
